const REASONS = [
  {
    icon: 'ri-home-5-line',
    title: 'More Space for Everyone',
    body: 'Cabins typically offer more interior and exterior space than hotel rooms, giving dogs room to move around comfortably. Covered decks and wooded surroundings add extra outdoor space right outside the door.',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Direct Access to Nature',
    body: 'Many cabins in Highlands are positioned within minutes of hiking trails and waterfall access points. Staying in a cabin means you can head out for a morning walk with your dog without driving anywhere.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Close to Trails and Waterfalls',
    body: 'Pet-friendly cabins in Highlands, NC are especially popular with visitors looking to stay close to hiking trails, waterfalls, and the natural beauty of the Blue Ridge Mountains.',
  },
];

export default function WhyChooseSection() {
  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Why Cabins</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light leading-tight mb-6">
            Why Choose a Pet-Friendly<br /><em className="italic">Cabin in Highlands NC</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
            Highlands, North Carolina is a strong destination for travelers bringing dogs. At 4,118 feet in the Blue Ridge Mountains, the town offers a combination of cool mountain air, forested trails, cascading waterfalls, and a landscape that suits active visitors and their pets equally well.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {REASONS.map((r) => (
            <div key={r.title} className="bg-[#FAFAF8] rounded-2xl p-8">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EDE8E0] mb-5">
                <i className={`${r.icon} text-[#2D4A3E] text-lg`} />
              </div>
              <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-3">{r.title}</h3>
              <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{r.body}</p>
            </div>
          ))}
        </div>

        <div className="bg-[#FAFAF8] rounded-2xl p-10 max-w-4xl">
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
            For visitors planning a trip to Highlands with dogs, a cabin stay generally offers a more practical and comfortable experience than a hotel. The wooded surroundings, outdoor living areas, and proximity to nature make cabin accommodations a natural fit for pet-friendly travel in this part of western North Carolina.
          </p>
        </div>
      </div>
    </section>
  );
}
